export const cloudinaryRawUrl = (url: string) => {
  if (!url.match(/cloudinary.com/)) return url;
  return url
    .split("/")
    .filter((urlPart: string) => !urlPart.match(/^([a-z]+_[a-z0-9]+)(,[a-z]+_[a-z0-9]+)*$/))
    .join("/");
};
